import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { PropertyLocationModel } from '@/api/models/propertyLocation';
import { TenantModel } from '@/api/models/tenant';
import { UnitModel } from '@/api/models/unit';
import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export type ApiRequest_GetAllInPropertyLocation_Unit = {
  propertyLocationId?: PropertyLocationModel['id'];
};

export type ApiResponse_GetAllInPropertyLocation_Unit = Array<
  UnitModel & {
    tenants: Array<Pick<TenantModel, 'full_name'>>;
  }
>;

const METHOD = 'GET';
const ENDPOINT = 'property-location/:id/units';
export const QUERY_KEY = (params?: ApiRequest_GetAllInPropertyLocation_Unit) =>
  getQueryKey(METHOD, ENDPOINT, params);

export const useGetAllUnitsInPropertyLocation = (
  params: ApiRequest_GetAllInPropertyLocation_Unit,
  enabled = true
) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token && !!params.propertyLocationId,
    queryKey: QUERY_KEY(params),
    queryFn: async () => {
      try {
        const data = await handleApiCall<ApiResponse_GetAllInPropertyLocation_Unit>(
          session,
          METHOD,
          getResolvedEndpoint(ENDPOINT, {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            id: params.propertyLocationId!.toString(),
          })
        );

        return data;
      } catch (err) {
        enqueueSnackbar('Failed to fetch units.', { variant: 'error' });

        // eslint-disable-next-line no-console
        console.error(err);

        throw err;
      }
    },
  });
};
